import React from 'react';
import type { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLockKeyhole } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { styled, theme } from '@components-shared/src/stitches';
import { Tooltip } from '@components/main-components/tooltip/Tooltip';

export const LockIcon = ({
  size = 'lg',
  gap = 'lg',
  align,
  tooltipText = 'Cannot be updated',
}: {
  size?: SizeProp;
  gap?: 'sm' | 'lg';
  align?: 'right';
  tooltipText?: string;
}) => {
  return (
    <LockIconContainer gap={gap} align={align}>
      <Tooltip openOnClick={false}>
        <Tooltip.Trigger>
          <FontAwesomeIcon
            icon={faLockKeyhole}
            color={theme.colors.base500.toString()}
            size={size}
          />
        </Tooltip.Trigger>
        <Tooltip.StyledContent>
          <p>{tooltipText}</p>
        </Tooltip.StyledContent>
      </Tooltip>
    </LockIconContainer>
  );
};

const LockIconContainer = styled('div', {
  '&:hover': {
    svg: {
      color: '$base900',
    },
  },
  variants: {
    gap: {
      sm: {
        marginLeft: 6,
      },
      lg: {
        marginLeft: 8,
      },
    },
    align: {
      right: {
        marginLeft: 'auto',
      },
    },
  },
});
